class IbmediaController {
    /**
     * Constructor for IbmediaController class.
     * @param {Object} $scope - Angular scope object.
     * @param {Object} $signals - Signal handling service.
     * @param {Object} $compile - Angular compile service.
     */
    constructor($scope, $signals, $compile) {
        this.$scope = $scope;
        this.$signals = $signals;
        this.$compile = $compile;

        // Generate a temporary UUID for unique signal creation
        this.$scope.tmpUUID = angular.createUUID();

        // Creating a unique signal, iframe will trigger this signal on 'loadeddata'
        this.signal = 'ibmedia-' + this.$scope.tmpUUID;

        // Register a callback for the unique signal
        this.$signals.on(this.signal, (data) => {
            if (data.success) {
                // Execute the videoLoaded function if it exists in the scope
                if (angular.isFunction(this.$scope.videoLoaded))
                    this.$scope.videoLoaded();
            }
        });
    }
}

/**
 * Registers the ibmedia directive with the provided module.
 * @param {Object} module - Angular module to register the directive with.
 */
export default function registerIbmediaDirective(angular) {
    angular.module('assessmentFrontendDirectives').directive('ibmedia', ['$compile', '$config', '$rootScope', '$translate', '$routeParams', '$timeout', 'TaskInfoService',
        function ($compile, $config, $rootScope, $translate, $routeParams, $timeout, TaskInfoService) {
            return {
                restrict: 'E',
                templateUrl: '/views/ib/components/MediaDirective.html',
                scope: {
                    thumbnail: '@',
                    src: '=',
                    subtitle: '=',
                    background: '=',
                    subtitleOnPlay: '=',
                    height: '@',
                    width: '@',
                    type: '@'
                },
                controller: ['$scope', '$signals', '$compile', IbmediaController],
                link: function (scope, iElement, iAttrs) {
                    // Watch for changes in video attributes and reinitialize scope if necessary
                    scope.$watchCollection('[src, subtitle, height, width, subtitleOnPlay]', function (newValues, oldValues) {
                        initScope();
                    });

                    /**
                     * Initializes or reinitializes the scope for the directive.
                     */
                    function initScope() {
                        var iframeQueryString = {};
                        var iframeRoot = '/media.html';

                        // Translations for user actions
                        var language = {
                            postrollClose: $translate.instant('VIDEOPLAYER.POSTROLLCLOSE'),
                            fullscreen: $translate.instant('VIDEOPLAYER.FULLSCREEN'),
                            playpause: $translate.instant('VIDEOPLAYER.PLAYPAUSE'),
                            mute: $translate.instant('VIDEOPLAYER.MUTE'),
                            stop: $translate.instant('VIDEOPLAYER.STOP'),
                            enableSubtitle: $translate.instant('VIDEOPLAYER.SUBTITLE_ON'),
                            caption: $translate.instant('VIDEOPLAYER.CAPTION'),
                            caption_none: $translate.instant('VIDEOPLAYER.CAPTION_NONE')
                        };

                        // Set iframe dimensions
                        scope.iframeWidth = scope.width || -1;
                        scope.iframeHeight = scope.height || -1;

                        /**
                         * Builds the source URL for the iframe based on the provided parameters.
                         * @param {string} subtitle - Subtitle URL.
                         * @param {number} width - Width of the iframe.
                         * @param {number} height - Height of the iframe.
                         * @returns {string} - The constructed iframe source URL.
                         */
                        scope.buildIframeSrc = function (subtitle, width, height) {
                            var thumbSuffix = '.png';
                            if (scope.thumbnail)
                                thumbSuffix = scope.thumbnail;

                            var subtitleUrl = subtitle || '';

                            if (scope.type == 'video') {
                                iframeQueryString['noBigPlayButton'] = iAttrs.noBigPlayButton == '1' ? '1' : '0';
                                iframeQueryString['allowFullscreen'] = iAttrs.allowFullscreen == '1' ? '1' : '0';
                                iframeQueryString['mp4'] = $config.getMediaURL(scope.src + '.mp4') + '?' + scope.tmpUUID;
                                iframeQueryString['webm'] = $config.getMediaURL(scope.src + '.webm') + '?' + scope.tmpUUID;
                                iframeQueryString['poster'] = $config.getMediaURL(scope.src + thumbSuffix) + '?' + scope.tmpUUID;
                            } else if (scope.type == 'audio') {
                                iframeQueryString['poster'] = scope.background ? thumbSuffix : $config.getMediaURL(scope.src.getMediaURL($routeParams.taskUUID) + thumbSuffix) + '?' + scope.tmpUUID;
                                if (!isCMS) {
                                    iframeQueryString['ogg'] = $config.getMediaURL(scope.src.getMediaURL($routeParams.taskUUID)) + '.ogg';
                                } else {
                                    iframeQueryString['mp3'] = $config.getMediaURL(scope.src.getMediaURL($routeParams.taskUUID)) + '.mp3';
                                }
                                iframeQueryString['allowFullscreen'] = 0;
                                iframeQueryString['noBigPlayButton'] = 0;
                            }

                            iframeQueryString['uuid'] = scope.tmpUUID;
                            iframeQueryString['height'] = height || scope.iframeHeight;
                            iframeQueryString['width'] = width || scope.iframeWidth;
                            iframeQueryString['type'] = scope.type;
                            iframeQueryString['subtitle'] = subtitleUrl;
                            iframeQueryString['subtitleOnPlay'] = scope.subtitleOnPlay ? '1' : '0';
                            iframeQueryString['languageCode'] = $rootScope.i18n.languageCode;
                            iframeQueryString['languageJSON'] = JSON.stringify(language);
                            iframeQueryString['direction'] = TaskInfoService.getTaskInfo().getWritingDirection();
                            iframeQueryString['sentryTraceId'] = '';
                            iframeQueryString['sentryDSN'] = window.SENTRY_DSN;

                            var queryStrings = [];
                            angular.forEach(iframeQueryString, function (value, key) {
                                queryStrings.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
                            });

                            return iframeRoot + '?' + queryStrings.join('&');
                        }

                        if (scope.subtitle)
                            scope.subtitle.getSecureURL($routeParams.taskUUID).then(function (url) {
                                scope.iframeSrc = scope.buildIframeSrc(url);
                            });
                        else
                            scope.iframeSrc = scope.buildIframeSrc();
                    }

                    initScope();
                }
            };
        }
    ]);
}